import { Icon } from "./Icon.tsx";

/** "Combined" Results Dashboard layout — one chart frame with 2 overlaid line traces, contrasting with the "Grid" layout's own LayoutGridIcon.tsx (4 SEPARATE frames) — the actual visual difference between the two layouts: one shared chart vs. one chart per element. */
export function ResultsDashboardCombinedIcon() {
  return (
    <Icon>
      <rect x="3" y="4" width="18" height="16" rx="1" />
      <path d="M5 15 9 10l3 3 4-6 3 4" />
      <path d="M5 17 9 13l3 2 4-4 3 3" strokeOpacity="0.55" />
    </Icon>
  );
}
